export default "__VITE_ASSET__CtfMK$Yg__"